import { render, staticRenderFns } from "./Apoio.vue?vue&type=template&id=a2fea10e&scoped=true"
import script from "./Apoio.vue?vue&type=script&lang=js"
export * from "./Apoio.vue?vue&type=script&lang=js"
import style0 from "./Apoio.vue?vue&type=style&index=0&id=a2fea10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fea10e",
  null
  
)

export default component.exports